import 'angular';

import { Mitchell1States }       from './mitchell1.states.ajs';
import { Mitchell1Service }      from './mitchell1.service';
import { Mitchell1SettingsCtrl } from './mitchell1.settings';

angular.module('workshop.mitchell1', [])
  .config(Mitchell1States)
  .controller('Mitchell1SettingsCtrl', Mitchell1SettingsCtrl)
  .factory('Mitchell1', Mitchell1Service);
